import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import { connect } from "react-redux";
import actionTypes from "../../store/actions";
// API helper and constant
import BusApiCall from "../../helper/axios.js";
import constants from "../../helper/constants";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { withStyles } from "@mui/material/styles";
import Loader from "../../component/loader";
import CreatableSelect from "react-select/creatable";
import ProviderConfirmation from "./providerConfirmation";
import { withTranslation } from "react-i18next";
class ManageSolutionProviders extends Component {
  state = {
    loading: true,
    solutionProvidersList: [],
    serviceProvidersList: [],
    selectedSolutionProvider: null,
    selectedSalesChannels: [],
    openDialog: false,
    selectedItem: {},
    selectedAction: null,
  };
  componentDidMount() {
    this.props.setCompDidMount();
    this.getProvidersList();
  }

  getProvidersList = () => {
    Promise.all([
      BusApiCall("GET", `${constants.busV4Url}/solution-providers`),
      BusApiCall("GET", `${constants.busV4Url}/service-providers`),
    ])
      .then((res) => {
        let solutionProvidersList = res[0].data;
        solutionProvidersList.filter((a) => (a.selected = false));
        let serviceProvidersList = res[1].data;
        serviceProvidersList.filter((a) => (a.selected = false));
        this.setState({
          solutionProvidersList,
          serviceProvidersList,
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  updateSelectedItems = () => {
    let payload = {
      fromPartyId: this.state.selectedSolutionProvider.id,
      toPartyId: this.state.selectedItem.id,
    };
    this.setState({ loading: true });
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/${this.state.selectedAction ? "REMOVE_PARTY_LINK" : "STORE_PARTY_LINK"}/endpoint`,
      payload,
    )
      .then((res) => {
        for (var i = 0; i < this.state.serviceProvidersList.length; i++) {
          if (
            this.state.serviceProvidersList[i].id === this.state.selectedItem.id
          ) {
            this.state.serviceProvidersList[i].selected = this.state
              .selectedAction
              ? false
              : true;
          }
        }
        this.setState({
          loading: false,
          selectedItem: {},
          selectedAction: null,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
          selectedItem: {},
          selectedAction: null,
        });
      });
  };

  selectSolutionProvider = (data) => {
    if (data) {
      if (data._isNew_) {
        console.log("new option not allowed");
      } else {
        for (var i = 0; i < this.state.serviceProvidersList.length; i++) {
          this.state.serviceProvidersList[i].selected = false;
        }
        this.setState({ loading: true });
        let payload = {
          partyId: data.id,
        };
        BusApiCall(
          "POST",
          `${constants.busInternalUrl}/passthru/GET_PARTY_LINK/endpoint`,
          payload,
        )
          .then((res) => {
            this.setState({
              selectedSalesChannels: res.data.salesChannelProviders,
            });
            let serviceProviders = res.data.serviceProviders;
            for (var i = 0; i < serviceProviders.length; i++) {
              for (var j = 0; j < this.state.serviceProvidersList.length; j++) {
                if (
                  serviceProviders[i].id ===
                  this.state.serviceProvidersList[j].id
                ) {
                  this.state.serviceProvidersList[j].selected = true;
                }
              }
            }
            this.setState({ loading: false });
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
        this.setState({
          selectedSolutionProvider: data,
        });
      }
    } else {
      this.setState({
        selectedSolutionProvider: {},
      });
    }
  };

  openConfirmationDialog = (item, value) => {
    this.setState({
      selectedItem: item,
      selectedAction: value,
      openDialog: true,
    });
  };

  onConfirmation = (value) => {
    if (value) {
      this.setState({
        openDialog: false,
      });
      this.updateSelectedItems();
    } else {
      this.setState({
        selectedItem: {},
        selectedAction: null,
        openDialog: false,
      });
    }
  };

  render() {
    const CustomColorCheckbox = withStyles({
      root: {
        color: "#b3b3b3",
        "&$checked": {
          color: this.props.tenantData.color
            ? this.props.tenantData.color
            : "#70b2e8",
        },
      },
      checked: {},
    })((props) => <Checkbox color="default" {...props} />);
    const t = this.props.t;
    return (
      <main>
        <Grid container spacing={2}>
          <Grid
            item
            size={{
              xs: 12,
            }}
          >
            <Grid container spacing={2}>
              <Grid
                item
                size={{
                  xs: 4,
                }}
              >
                <h3>{t("SELECT_SOLUTION_PROVIDER")}</h3>
                <div style={{ width: "90%" }}>
                  <CreatableSelect
                    // components={{ Option }}
                    classNamePrefix="SearchInputClassPrefix"
                    className={"SearchInputClassPrefix__myinputOuter"}
                    isClearable={true}
                    isSearchable={
                      this.state.selectedSolutionProvider ? false : true
                    }
                    name="color"
                    formatCreateLabel={(value) => ""}
                    options={this.state.solutionProvidersList.map((a) => {
                      return {
                        label: a.name,
                        value: a.id,
                        id: a.id,
                      };
                    })}
                    value={this.state.selectedSolutionProvider}
                    placeholder=""
                    menuPosition={"fixed"}
                    onChange={(e) => {
                      this.selectSolutionProvider(e);
                    }}
                    onCreateOption={""}
                  />
                  {/* <div>
                                    {this.state.selectedSolutionProvider && this.state.selectedSolutionProvider.label}
                                </div> */}
                </div>
              </Grid>
              {this.state.selectedSolutionProvider ? (
                <>
                  <Grid
                    item
                    size={{
                      xs: 4,
                    }}
                  >
                    <h3>{t("SALES_CHANNELS")}</h3>
                    <FormGroup component="fieldset">
                      {this.state.selectedSalesChannels.map((item, i) => (
                        <FormControlLabel
                          control={
                            <CustomColorCheckbox
                              value={item.id}
                              checked={true}
                              name={"sales" + i}
                            />
                          }
                          label={item.name}
                          key={i}
                          disabled={true}
                        />
                      ))}
                    </FormGroup>
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 4,
                    }}
                  >
                    <h3>{t("SERVICE_PROVIDERS")}</h3>
                    <FormGroup component="fieldset">
                      {this.state.serviceProvidersList.map((item, i) => (
                        <FormControlLabel
                          control={
                            <CustomColorCheckbox
                              value={item.id}
                              onChange={() =>
                                this.openConfirmationDialog(item, item.selected)
                              }
                              checked={item.selected}
                              name={"sales" + i}
                            />
                          }
                          label={item.name}
                          key={i}
                        />
                      ))}
                    </FormGroup>
                  </Grid>
                </>
              ) : (
                <Grid
                  item
                  align="center"
                  size={{
                    xs: 4,
                  }}
                >
                  <h3 style={{ marginTop: "60px" }}>
                    {t("No Solution Provider Selected")}
                  </h3>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
        <ProviderConfirmation
          item={this.state.selectedItem}
          action={this.state.selectedAction}
          open={this.state.openDialog}
          close={this.onConfirmation}
          t={t}
        />
        <Loader loading={this.state.loading} />
      </main>
    );
  }
}

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    providerType: state.auth.providerType,
    tenantId: state.auth.tenantId,
    tenantData: state.auth.tenantData,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(ManageSolutionProviders));
